module.exports = __webpack_public_path__ + "img/chinabank.65ed5495.gif";